import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString, deleteQueryString } from 'services/router/actions';

// Workspaces
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    clearable?: boolean;
    singleFilter?: boolean;
}

const ProductDropdown = ({
    clearable,
    singleFilter
}: Props): React.ReactElement => {
    const dispatch = useDispatch();

    const sprayProductId: number = useSelector(
        makeSelectQueryStringNumberValue('sprayProductId')
    );
    const productOptions = useSelector(selectOptions);

    const handleChange = (event: any, data: any) => {
        if (singleFilter) dispatch(deleteQueryString());

        dispatch(updateQueryString({ sprayProductId: data.value }));
    };

    return (
        <Dropdown
            placeholder="All Products"
            search
            selection
            value={sprayProductId}
            clearable={clearable}
            selectOnBlur={false}
            options={productOptions}
            onChange={handleChange}
            lazyLoad
            closeOnChange
            fluid
        />
    );
};

ProductDropdown.defaultProps = {
    clearable: true,
    singleFilter: false
};

export default ProductDropdown;
